import { ProductTileVerticalFormat, ProductDeliveryPromiseExplanations } from './product-detail';

export type RecentlyViewedProduct = {
  productCode: string;
  colorId: number;
};

export type ProductRecentlyViewedContainerProps = {
  tileFormat: ProductTileVerticalFormat;
  deliveryPromiseExplanations: ProductDeliveryPromiseExplanations;
  collapsed?: boolean;
  collapsible: boolean;
};
